import { useEffect, useState } from 'react'
import { sendGet } from 'hooks/use-fetch'
import { type carenetworkService } from 'core/types'
import { Box, CircularProgress } from '@mui/material'
import { EnrollmentCard } from 'Components/Cards/CaregiverPortal/EnrollmentCard'
import { generatePath, useNavigate } from 'react-router'
import { CAREGIVER_PORTAL_MEMBERS_SERVICE_DETAILS } from 'Pages/Routes'

export interface ChildServicesProps {
  childID: number
  canEdit: boolean
}

export function ChildServices (props: ChildServicesProps): JSX.Element {
  const [loading, setLoading] = useState(true)
  const [services, setServices] = useState<carenetworkService[]>([])
  const nav = useNavigate()

  useEffect(() => {
    async function getServices (): Promise<void> {
      const { response, success } = await sendGet(`/CaregiverPortal/GetServices?id=${props.childID}`, {})
      if (success) {
        setServices(response)
      }
      setLoading(false)
    }
    void getServices()
  }, [])

  const viewEnrollmentDetails = (service: carenetworkService): void => {
    nav(generatePath(CAREGIVER_PORTAL_MEMBERS_SERVICE_DETAILS, { enrollmentId: service?.enrollmentID?.toString() ?? '' }))
  }

  if (loading) {
    return <CircularProgress />
  } else {
    return <Box sx={{ display: 'flex', flexDirection: 'column', gap: '12px' }}>
      {services.length === 0 && <Box>There are no services for this child.</Box>}
      {services.map((service) => (
        <EnrollmentCard
          key={service.serviceID}
          service={service}
          onClick={viewEnrollmentDetails}
        />
      ))}
    </Box>
  }
}
